import FuturisticLogo from '../components/FuturisticLogo';

const TAB_ICONS = {
  myday: 'M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4',
  sales: 'M12 2v20M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6',
  ads: 'M2 16l6-6 4 4 8-10M22 12v4a2 2 0 01-2 2H4a2 2 0 01-2-2V6a2 2 0 012-2h6',
  creative: 'M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z',
  stock: 'M3 20h18M6 16l4-8 4 4 5-9',
  finance: 'M4 2h10l4 4v14a2 2 0 01-2 2H4a2 2 0 01-2-2V4a2 2 0 012-2zm9 0v5h5M7 13h8M7 17h5',
  files: 'M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z',
  team: 'M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2M9 11a4 4 0 100-8 4 4 0 000 8z',
  contacts: 'M19 4h-1V3a1 1 0 00-2 0v1H8V3a1 1 0 00-2 0v1H5a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2V6a2 2 0 00-2-2z',
  archive: 'M21 8v13H3V8M1 3h22v5H1zM10 12h4',
};

const TAB_LABELS = {
  myday: 'My Day', sales: 'Sales', ads: 'Ads', creative: 'Creative',
  stock: 'Stock', finance: 'Finance', files: 'Files', team: 'Team',
  contacts: 'Contacts', archive: 'Archive',
};

const ROLE_COLORS = { admin: '#7c3aed', user: '#2563eb', viewer: '#64748b', contractor: '#d97706' };
const ROLE_LABELS = { admin: 'Admin', user: 'Staff', viewer: 'Viewer', contractor: 'Contractor' };
const DEPT_COLORS = { Leadership: '#0a0a0a', Marketing: '#7c3aed', Operations: '#2563eb', Engineering: '#111', Design: '#ec4899', 'Customer Care': '#16a34a', Creative: '#d97706' };

export default function Welcome({ session, onDismiss }) {
  const name = session?.name?.split(' ')[0] || 'there';
  const role = session?.role || 'user';
  const dept = session?.department || 'Team';
  const perms = session?.permissions || {};
  const isAdmin = role === 'admin';

  const accessibleTabs = Object.keys(TAB_LABELS).filter(k => isAdmin || perms[k] !== false);

  const today = new Date().toLocaleDateString('en-AU', { day: '2-digit', month: 'long', year: 'numeric' });

  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 400, background: '#fff',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      animation: 'welcomeFadeIn 0.4s ease-out',
    }}>
      {/* Subtle gradient top */}
      <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: 300, background: 'radial-gradient(ellipse at 50% 0%, rgba(124,58,237,0.06) 0%, transparent 70%)', pointerEvents: 'none' }} />

      <div style={{ position: 'relative', maxWidth: 640, width: '100%', padding: '0 24px' }}>
        {/* 1. Header */}
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 16 }}>
            <FuturisticLogo size={56} />
          </div>
          <h1 style={{ fontSize: 28, fontWeight: 700, color: '#0a0a0a', margin: '0 0 6px' }}>
            Welcome to moreece.com, {name}
          </h1>
          <p style={{ fontSize: 14, color: '#a1a1aa', margin: 0 }}>Your operating system for First or Nothing</p>
        </div>

        {/* 2. Role card */}
        <div style={{ background: '#fafafa', border: '1px solid #e4e4e7', borderRadius: 12, padding: '16px 20px', marginBottom: 24, display: 'flex', alignItems: 'center', gap: 12 }}>
          <div style={{ width: 40, height: 40, borderRadius: '50%', background: `hsl(${(name.charCodeAt(0) * 37) % 360}, 45%, 60%)`, color: '#fff', fontSize: 16, fontWeight: 700, display: 'flex', alignItems: 'center', justifyContent: 'center', border: '2px solid #fff', boxShadow: '0 2px 8px rgba(0,0,0,0.08)', flexShrink: 0 }}>
            {name.charAt(0)}
          </div>
          <div style={{ flex: 1 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
              <span style={{ fontSize: 10, fontWeight: 600, padding: '2px 8px', borderRadius: 999, background: `${ROLE_COLORS[role] || '#2563eb'}15`, color: ROLE_COLORS[role] || '#2563eb' }}>{ROLE_LABELS[role] || 'Staff'}</span>
              <span style={{ fontSize: 10, fontWeight: 600, padding: '2px 8px', borderRadius: 999, background: `${DEPT_COLORS[dept] || '#64748b'}12`, color: DEPT_COLORS[dept] || '#64748b' }}>{dept}</span>
            </div>
            <div style={{ fontSize: 13, color: '#52525b', marginTop: 4 }}>
              You've been set up as <strong>{ROLE_LABELS[role] || 'Staff'}</strong> on the <strong>{dept}</strong> team by Mo
            </div>
          </div>
        </div>

        {/* 3. What you can access */}
        <div style={{ marginBottom: 24 }}>
          <div style={{ fontSize: 12, fontWeight: 500, color: '#a1a1aa', marginBottom: 10, textTransform: 'uppercase', letterSpacing: '0.05em' }}>Here's what's in your scope</div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 8 }}>
            {accessibleTabs.map(k => (
              <div key={k} style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '10px 14px', background: '#fff', border: '1px solid #e4e4e7', borderRadius: 10 }}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#7c3aed" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0 }}>
                  <path d={TAB_ICONS[k] || TAB_ICONS.myday} />
                </svg>
                <span style={{ fontSize: 13, fontWeight: 500, color: '#0a0a0a' }}>{TAB_LABELS[k]}</span>
              </div>
            ))}
          </div>
        </div>

        {/* 4. Meet your assistant */}
        <div style={{ background: '#fafafa', border: '1px solid #e4e4e7', borderRadius: 12, padding: '16px 20px', marginBottom: 24 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 10 }}>
            <div style={{ width: 32, height: 32, borderRadius: '50%', background: 'linear-gradient(135deg, #7c3aed, #6366f1)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2"><circle cx="12" cy="12" r="10" /><circle cx="12" cy="12" r="3" /></svg>
            </div>
            <div style={{ fontSize: 14, fontWeight: 600, color: '#0a0a0a' }}>Meet your assistant</div>
          </div>
          <p style={{ fontSize: 13, color: '#52525b', lineHeight: 1.6, margin: '0 0 12px' }}>
            Every tab has an assistant scoped to your access. Ask it anything about your work. It can't see what you can't.
          </p>
          <div style={{ background: '#fff', border: '1px solid #e4e4e7', borderRadius: 10, padding: '10px 14px', fontSize: 12, color: '#52525b', display: 'flex', alignItems: 'center', gap: 8 }}>
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#7c3aed" strokeWidth="2"><circle cx="12" cy="12" r="10" /><circle cx="12" cy="12" r="3" /></svg>
            <span>Try asking: <em style={{ color: '#7c3aed' }}>"What should I focus on today?"</em></span>
          </div>
        </div>

        {/* 5. Quick tour CTA */}
        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          <button style={{ padding: '12px 32px', fontSize: 14, fontWeight: 600, borderRadius: 10, border: 'none', background: '#7c3aed', color: '#fff', cursor: 'pointer', fontFamily: 'inherit', boxShadow: '0 4px 16px rgba(124,58,237,0.25)', marginBottom: 10 }}>
            Take the 60-second tour
          </button>
          <div>
            <button onClick={onDismiss} style={{ background: 'none', border: 'none', fontSize: 13, color: '#a1a1aa', cursor: 'pointer', fontFamily: 'inherit' }}>
              Skip to My Day
            </button>
          </div>
        </div>

        {/* 6. Footer */}
        <div style={{ textAlign: 'center', fontSize: 11, color: '#a1a1aa' }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6 }}>
            <div style={{ width: 18, height: 18, borderRadius: '50%', background: 'linear-gradient(135deg, #7c3aed, #6366f1)', color: '#fff', fontSize: 8, fontWeight: 700, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>M</div>
            Set up by Mo on {today}
          </div>
          <div style={{ marginTop: 4 }}>Questions? Ping Mo in Slack</div>
        </div>
      </div>
    </div>
  );
}
